module.exports = __webpack_public_path__ + "media/images/but-upload-form-4bc8f5f3.png";